import React from "react"
import DropdownButton from "react-bootstrap/DropdownButton"
import Dropdown from "react-bootstrap/Dropdown"
import { useNavigate, useLocation } from "react-router-dom"
import useT from "utils/hooks/useT"

export default function WeekDropDown({ memberId }) {
  const { t } = useT("common")
  const dropDownOptions = [
    { url: `/member/${memberId}`, name: t("weekView") },
    { url: `/member/${memberId}/day`, name: t("dayView") },
    { url: `/member/${memberId}/weekend`, name: t("weekendView") },
  ]
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <DropdownButton
      title={dropDownOptions.find((el) => el.url === location.pathname).name || t("screen")}
      onSelect={(view) => navigate(view)}
    >
      {dropDownOptions.map((view) => {
        return (
          <Dropdown.Item key={view.url} active={view === location.pathname} eventKey={view.url}>
            {view.name}
          </Dropdown.Item>
        )
      })}
    </DropdownButton>
  )
}
